import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SearchIcon } from '../../../utils/icons'; // use your search icon

/* ---------------- Styled Components ---------------- */

const SearchWrapper = styled.div`
  display: flex;
  width: ${({ width }) => width || '360px'};
  height: 40px;
  padding: 12px;
  justify-content: space-between;
  align-items: center;

  border-radius: 8px;
  border: 0.75px solid #dcdcdc;
  background: #fefefe;
`;

const SearchInputField = styled.input`
  border: none;
  outline: none;
  width: 100%;

  font-family: Lato;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;

  color: #333;

  &::placeholder {
    color: #bdbdbd;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 8px;
  cursor: pointer;
`;

/* ---------------- Component ---------------- */

const SearchInput = ({
  value = '',
  placeholder = 'Search',
  onChange,
  onSearch,
  debounce = 0,
  width,
}) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  // Debounce search
  useEffect(() => {
    if (!debounce) return;

    const timer = window.setTimeout(() => {
      onSearch?.(localValue);
    }, debounce);

    return () => window.clearTimeout(timer);
  }, [localValue, debounce, onSearch]);

  const handleChange = (e) => {
    const val = e.target.value;
    setLocalValue(val);
    onChange?.(val);
    if (!debounce) onSearch?.(val);
  };

  return (
    <SearchWrapper width={width}>
      <SearchInputField
        type="text"
        value={localValue}
        onChange={handleChange}
        placeholder={placeholder}
      />

      <IconWrapper onClick={() => onSearch?.(localValue)}>
        {SearchIcon('#DA6C74')}
      </IconWrapper>
    </SearchWrapper>
  );
};

/* ---------------- PropTypes ---------------- */

SearchInput.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  debounce: PropTypes.number,
  width: PropTypes.string,
};

export default SearchInput;
